import React, { useState } from 'react';
import { Box, Button, Flex, Popover, Text } from 'core/components';
import CodeMirror from 'core/components/CodeMirror';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { Position } from '@blueprintjs/core';

const CodeMirrorWrap = styled(Box)`
  max-width: 500px;
  max-height: 500px;
  overflow: auto;
  padding: 4px;

  .CodeMirror {
    border-radius: 4px;
    font-size: 12px;
  }
`;

const JsonKvsRenderer = ({ value = '' }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  // Handle undefined, null, or empty values
  if (!value || value === '') {
    return <Text>--</Text>;
  }

  let parsedValue;
  try {
    parsedValue = JSON.parse(value);
    if (typeof parsedValue !== 'object' || parsedValue === null) {
      return <Text>{String(value)}</Text>;
    }
  } catch (error) {
    // If parsing fails, display the raw value
    return <Text>{String(value)}</Text>;
  }

  const jsonValue = JSON.stringify(parsedValue, null, 2);

  return (
    <Flex alignItems="center" gap={1}>
      <Popover
        minimal={false}
        position={Position.LEFT}
        isOpen={isPopoverOpen}
        onInteraction={(nextOpenState) => setIsPopoverOpen(nextOpenState)}
        onClose={() => setIsPopoverOpen(false)}
        usePortal
        content={
          <CodeMirrorWrap>
            <CodeMirror value={jsonValue} options={{ readOnly: true }} />
          </CodeMirrorWrap>
        }
      >
        <Flex alignItems="center" gap={1}>
          <Button small minimal icon="maximize" onClick={() => setIsPopoverOpen(!isPopoverOpen)} />
        </Flex>
      </Popover>
      <Text ellipsis>
        {Object.entries(parsedValue)
          .map(([k, v]) => `${k}=${JSON.stringify(v)}`)
          .join(', ')}
      </Text>
    </Flex>
  );
};

export default observer(JsonKvsRenderer);
